import React from 'react';
import { Section } from './ui/Section';
import { PricingCard } from './PricingCard';
import { CtaFrame } from './ui/CtaFrame';
import { UrgencyBadge } from './ui/UrgencyBadge';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { Shield, CreditCard } from 'lucide-react';
import { Divider } from './botanical/Divider';
export function CTA2() {
  return <Section className="bg-forest-mist" data-id="element-171">
      <div className="max-w-4xl mx-auto" data-id="element-172">
        <CtaFrame variant="forest" className="mb-8" data-id="element-173">
          <div className="flex justify-center mb-6" data-id="element-174">
            <UrgencyBadge variant="clock" tone="light" label="PRECIO DE LANZAMIENTO" data-id="element-175" />
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-176">
            <PricingCard title="HOGAR NATURAL" subtitle="5 Tomos + 5 Bonos" oldPrice="$34.000" price="$17.999" buttonText="→ QUIERO MIS 5 TOMOS AHORA" href={CHECKOUT_URLS.hogarNatural} data-id="element-177" />
            <PricingCard title="SUPER PACK HOGAR NATURAL" subtitle="5 Tomos + 5 Bonos + 5 Upsells Premium" oldPrice="$58.000" price="$27.999" buttonText="→ QUIERO EL SUPER PACK COMPLETO" href={CHECKOUT_URLS.superPack} isPopular data-id="element-178" />
          </div>
        </CtaFrame>

        <div className="flex items-center justify-center gap-4 flex-wrap text-sm text-forest/70 font-medium" data-id="element-179">
          <span data-id="element-180">Acceso inmediato</span>
          <span className="text-sage-deep" data-id="element-181">•</span>
          <span className="flex items-center gap-1" data-id="element-182">
            <Shield className="w-4 h-4 text-moss" data-id="element-183" /> Garantía 7 días
          </span>
          <span className="text-sage-deep" data-id="element-184">•</span>
          <span className="text-forest-deep flex items-center gap-1" data-id="element-185">
            <CreditCard className="w-4 h-4 text-moss" data-id="element-186" /> Mercado Pago
          </span>
        </div>
      </div>
      <Divider className="mt-16" data-id="element-187" />
    </Section>;
}